<template lang="html">
    <section class="orders-buyer-information">
        <div class="buyer-infos">
            <span class="buyer buyer-name">Joe Smith</span> <span class="buyer buyer-email">E-mail: joe.smith@loreal.com</span>
            <span class="buyer buyer-phone">Tel: +033 (0)6 12 12 12</span>
            <span class="buyer buyer-order"> <span class="orderNbr">7</span> Orders <button class="btn-orders">View order history</button> </span>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'orders-buyer-information',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes.scss";
.orders-buyer-information {
    @extend %primary-text;
    & .buyer {
        &-name {
            font-weight: bold;
            text-transform: uppercase !important;
        }
        &-infos {
            & .buyer {
                display: block;
                margin-bottom: 10px;
                font-size: 14px;
                font-family: "oswald-regular", sans-serif;
                text-transform: none;
            }
        }
        &-order {
            & button {
                text-transform: uppercase;
                margin-left: 20px;
            }
            & .orderNbr {
                display: inline;
                color: $color4;
                font-weight: bold;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// order-buyer-information.vue?6b835d14